export const load = () => ({
	title: 'Commercial Window Insert Pilot Program',
	showTitle: true,
});
